// This file should only contain action type constants.
export const SET_ACCORDION_CONTENT = 'SET_ACCORDION_CONTENT';
